import { render, staticRenderFns } from "./listado_periodos.vue?vue&type=template&id=3ced288a&scoped=true&"
import script from "./listado_periodos.vue?vue&type=script&lang=js&"
export * from "./listado_periodos.vue?vue&type=script&lang=js&"
import style0 from "./listado_periodos.vue?vue&type=style&index=0&id=3ced288a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ced288a",
  null
  
)

export default component.exports